import Helper from "@src/common/helper/core";

class Store {
  mid = ""; // 只取浏览器 mid
  m2 = '';
  _sid = ""; // 用户本地 id
  is360Browser = false;
  hasChecked = false;

  /**
   * 标识用户
   * 优先取浏览器 mid
   * 其次用户本地 localstorage id
   */
  get sid () {
    return this.mid || this._sid;
  }

  /**
   * 只取用户本地 id
   * “mid一样有可能是无盘服务器导致”
   * “这种用ghost盘装的。mid一样很正常”
   */
  get feid () {
    return this._sid;
  }

  constructor () {
    this.init();

    if(!Helper.IS_PROD){
      window._client360Store = this;
    }
  }

  getMid () {
    if(this.mid){
      return this.mid;
    }
    if(this.hasChecked){
      return "";
    }

    try{
      this.mid = external.GetMID(external.GetSID(window))
        || window.wdextcmd.GetMid()             // 调用安全卫士给IE浏览器种的方法
        || (Helper.getCookie('_uc_mid') ?? ''); // _uc_mid是用户中心给登录用户种的cookie
      this.is360Browser = true;
    } catch(e){}
    this.hasChecked = true;
    return this.mid;
  }

  getM2() {
    try {
      window.external.AppCmd(external.GetSID(window), '', 'GetMID2', '', '', (status, data) => {
        this.m2 = data;
      });
    } catch {}
  }

  init () {
    this._sid = Helper.getMid();
    this.getMid();
    this.getM2();
  }
}

const client360Store = new Store();
export default client360Store;